module.exports = __webpack_public_path__ + "img/emamRezaDetails2.4934fef5.png";